import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { media } from '../../globals';

const defaultPropsDefinition = {
    children: null,
    triggerWidth: '200px',
    popover: {
        content: null,
        backgroundColor: '#fcfcfc',
        borderRadius: '4px',
        filterShadow: '1px 1px 3px rgba(0,0,0,0.3)',
        width: '100%',
        zIndex: '1001'
    }
};

const PopoverWrapper = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
    
      ${media.sm`
        width: ${props => props.triggerWidth};
      `}
`;

const TriggerWrapper = styled.div`
    display:block;
    width: 100%;
    border: 0 solid #F00;
    margin: 0 auto;
`;

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
     }
    to {
        opacity: 1;
        transform: 0;
    }
`;

/* eslint-disable no-confusing-arrow */
const PopoverContent = styled.div`
    display: block;
    opacity: 0;
    position: absolute;
    transform: translate(0, 15px);
    padding: 1.5rem;
    width: ${props => props.popover.width ? props.popover.width : defaultPropsDefinition.popover.width};
    background-color: ${props => props.popover.backgroundColor ? props.popover.backgroundColor : defaultPropsDefinition.popover.backgroundColor};
    filter: drop-shadow(${props => props.popover.filterShadow ? props.popover.filterShadow : defaultPropsDefinition.popover.filterShadow});
    border-radius:  ${props => props.popover.borderRadius ? props.popover.borderRadius : defaultPropsDefinition.popover.borderRadius}; 
    z-index: ${props => props.popover.zIndex ? props.popover.zIndex : defaultPropsDefinition.popover.zIndex}; 
   
    &:before{
        position: absolute;
        z-index: -1;
        content: '';
        right: calc(50% - 10px);
        top: -8px;
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent ${props => props.popover.backgroundColor ? props.popover.backgroundColor : defaultPropsDefinition.popover.backgroundColor} transparent;
        transition-duration: 0.3s;
        transition-property: transform;
    }
`;
/* eslint-enable no-confusing-arrow */

const PopoverContentHover = styled(PopoverContent)`
    animation: ${fadeInUp} 1s;
    animation-fill-mode: forwards; 
    visibility: visible;
`;

class Popover extends React.Component {
    constructor() {
        super();
        this.state = {
            hoverActive: false,
            clickToggle: false
        };
    }

    render() {
        return (
            <PopoverWrapper {...this.props} class="popover-wrapper">
                <TriggerWrapper class="popover-trigger">
                    {this.addEventsToTriggerElement()}
                </TriggerWrapper>
                { (this.state.hoverActive || this.state.clickToggle) &&
                <PopoverContentHover {...this.props}>
                    {this.props.popover.content}
                </PopoverContentHover>
                }
            </PopoverWrapper>
        );
    }

    /**
     * @description There should only be a single child element; as the event triggers are
     * added to each, this will later require refactoring to provide additional
     * parameters to define the specific element to attach events to.
     * @returns {Array}
     */
    addEventsToTriggerElement = () => {
        const events = {
            onMouseOver: this.onHoverEntry,
            onMouseOut: this.onHoverExit,
            onClick: this.onClick
        };

        return React.Children.map(this.props.children,
            child => React.cloneElement(child, { ...events })
        );
    };

    onHoverEntry = () => {
        if (!this.state.hoverActive) { this.setState({ hoverActive: true }); }
    };

    onHoverExit = () => {
        if (this.state.hoverActive) { this.setState({ hoverActive: false }); }
    };

    onClick = () => {
        const window = global.window || null; // eslint-disable-line no-use-before-define
        this.setState({ clickToggle: !this.state.clickToggle }, () => {
            if (this.state.clickToggle) {
                window.document.body.addEventListener('click', this.onClick);
            } else {
                window.document.body.removeEventListener('click', this.onClick);
            }
        });
    };
}

Popover.propTypes = {
    children: PropTypes.node,
    triggerWidth: PropTypes.string,
    popover: PropTypes.shape({
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        backgroundColor: PropTypes.string,
        borderRadius: PropTypes.string,
        filterShadow: PropTypes.string,
        width: PropTypes.string,
        zIndex: PropTypes.string
    })
};

Popover.defaultProps = defaultPropsDefinition;

export default Popover;



// WEBPACK FOOTER //
// ./src/components/Popover/index.js